import i from "react";
import { Spinner as P } from "../Spinner/Spinner.js";
import { buttonDefaultProps as m } from "./props.js";
import { cls as p } from "../../helpers/cls.js";
import { forwardAsTagRef as W } from "../../helpers/forwardAsTagRef.js";
import { spacingReplace as l } from "../../helpers/spacingReplace.js";
var j = Object.defineProperty,
  s = Object.getOwnPropertySymbols,
  _ = Object.prototype.hasOwnProperty,
  g = Object.prototype.propertyIsEnumerable,
  x = (a, r, t) => r in a ? j(a, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : a[r] = t,
  c = (a, r) => {
    for (var t in r || (r = {})) _.call(r, t) && x(a, t, r[t]);
    if (s) for (var t of s(r)) g.call(r, t) && x(a, t, r[t]);
    return a;
  },
  z = (a, r) => {
    var t = {};
    for (var e in a) _.call(a, e) && r.indexOf(e) < 0 && (t[e] = a[e]);
    if (a != null && s) for (var e of s(a)) r.indexOf(e) < 0 && g.call(a, e) && (t[e] = a[e]);
    return t;
  };
typeof window != "undefined" && !window.__DS_WEB_VERSION__ && (window.__DS_WEB_VERSION__ = "3.35.0");
const w = W((a, r) => {
  const t = a,
    {
      variant: e = m.variant,
      className: v,
      disabled: n,
      fullWidth: h = m.fullWidth,
      size: d = m.size,
      tag: o,
      href: E,
      dsParentName: f,
      isLoading: u = m.isLoading,
      children: N,
      icon: b,
      margin: O,
      marginLeft: S,
      marginBottom: y,
      marginTop: B,
      marginRight: R
    } = t,
    D = z(t, ["variant", "className", "disabled", "fullWidth", "size", "tag", "href", "dsParentName", "isLoading", "children", "icon", "margin", "marginLeft", "marginBottom", "marginTop", "marginRight"]),
    L = o != null ? o : "button";
  return i.createElement(L, c(c(c(c({
    "data-ds-component": f ? "DS-".concat(f, "-Button") : "DS-Button",
    className: p("olx-button", "olx-button--".concat(e), "olx-button--".concat(d), h && "olx-button--fullwidth", o === "a" && "olx-button--a", n && "olx-button--disabled", v, l("olx-m", O), l("olx-ml", S), l("olx-mb", y), l("olx-mt", B), l("olx-mr", R)),
    ref: r
  }, o !== "a" && {
    disabled: n
  }), o === "a" && !n && {
    href: E
  }), o === "a" && n && {
    role: "link",
    "aria-disabled": !0
  }), D), u && i.createElement(P, {
    "aria-label": "loading",
    color: "currentColor",
    size: d === "small" ? "extra-small" : "small",
    className: "olx-button__spinner"
  }), i.createElement("span", {
    className: p("olx-button__content-wrapper", u && "olx-button__content-wrapper--loading")
  }, b && i.createElement("span", {
    className: p("olx-button__icon-wrapper", d === "small" && "olx-button__icon-wrapper--small")
  }, b), N));
});
w.displayName = "Button";
export { w as Button };